module.exports = __webpack_public_path__ + "static/media/member-introduction-maciej-polak.7fe45da3.jpg";